import { Link } from 'react-router-dom';
import { Cpu, HardDrive, Network, Lock, RefreshCw, Wrench, ArrowRight } from 'lucide-react';
import { products } from '../../data/products';

const PRODUCT_ICONS = {
  compute: Cpu, storage: HardDrive, networking: Network,
  'cloud-security': Lock, 'backup-dr': RefreshCw, 'managed-cloud': Wrench
};

export const ProductsMenu = () => (
  <div className="bg-[#120836] border border-white/10 rounded-2xl shadow-[0_30px_80px_rgba(0,0,0,0.5)] w-[820px] relative overflow-hidden flex" data-testid="products-mega-panel">
    <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#F29B3D]/40 to-transparent" />

    {/* 6 core products */}
    <div className="flex-1 p-5">
      <p className="text-[#F29B3D] text-[10px] font-extrabold tracking-[2px] uppercase px-3 mb-1.5">
        Core Products
      </p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-0.5">
        {products.map((p) => {
          const Icon = PRODUCT_ICONS[p.id] || Cpu;
          return (
            <Link
              key={p.id}
              to={`/products/${p.id}`}
              data-testid={`dropdown-product-${p.id}`}
              className="flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-white/[0.05] transition-colors duration-150 group/item"
            >
              <Icon className="w-4 h-4 text-[#F29B3D]/80 mt-0.5 shrink-0" strokeWidth={1.5} />
              <span className="min-w-0">
                <span className="block text-[13px] font-medium text-[#DCE4EE] group-hover/item:text-white leading-snug transition-colors">{p.name}</span>
                <span className="block text-[11px] text-[#94A3B8]">{p.navDesc}</span>
              </span>
            </Link>
          );
        })}
      </div>
      <Link
        to="/products"
        data-testid="dropdown-view-all-products"
        className="mt-3 ml-3 inline-flex items-center gap-1.5 text-[#F29B3D] hover:text-white text-[13px] font-semibold transition-colors group/all"
      >
        View all products
        <ArrowRight className="w-3.5 h-3.5 group-hover/all:translate-x-0.5 transition-transform" />
      </Link>
    </div>

    {/* Side rail */}
    <div className="w-[230px] shrink-0 border-l border-white/[0.07] bg-white/[0.02] p-6">
      <p className="text-[#F29B3D] text-[10px] font-extrabold tracking-[2px] uppercase mb-3">Go Deeper</p>
      <p className="text-[#CBD5E1] text-[12.5px] leading-relaxed mb-4">
        Each product is delivered through 27 individual platform services.
      </p>
      <Link
        to="/services"
        data-testid="dropdown-full-catalog"
        className="block text-[#CBD5E1] hover:text-white text-[13px] font-medium mb-2.5 transition-colors"
      >
        Full service catalog
      </Link>
      <Link
        to="/pricing"
        data-testid="dropdown-products-pricing"
        className="block text-[#CBD5E1] hover:text-white text-[13px] font-medium transition-colors"
      >
        Request pricing
      </Link>
      <div className="mt-5 pt-5 border-t border-white/[0.07]">
        <Link
          to="/cloud-access"
          data-testid="dropdown-products-request-access"
          className="block text-center text-[13px] font-semibold text-white bg-[#F29B3D] hover:bg-[#DD8226] rounded-lg px-4 py-2.5 transition-colors"
        >
          Request Cloud Access
        </Link>
      </div>
    </div>
  </div>
);
